import {removeCookie} from 'app/lib/cookies';
import * as qs from 'app/lib/helperjs';

const COOKIE_TO_REMOVE = 'Language';
const LANGUAGE_CHANGER_SELECTOR = '[data-language-changer]';

export const LanguageChangerCookie = () => {
    const changers = qs.querySelectorAll(LANGUAGE_CHANGER_SELECTOR);

    qs.addEventListener(changers, 'click', () => {
        removeCookie(COOKIE_TO_REMOVE);
    });
};